/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isNil from 'lodash/isNil';

import FileSystemPath from '../../../../core/file/system/file-system-path';
import FileSystemType from '../../../../core/file/system/file-system-type';
import FileSystemDirectory from './file-system-directory';

/**
 * @import { FileSystemUnit as IFileSystemUnit } from '../../../../core/file/system'
 * @import FileSystemManager from './file-system-manager'
 */

/**
 * @implements {IFileSystemUnit}
 */
class FileSystemUnit {
  /**
   * @param {FileSystemManager} fileSystemManager
   * @param {StorageManager} storage
   */
  constructor(fileSystemManager, storage) {
    this.fileSystemManager = fileSystemManager;
    this.storage = storage;
  }

  /** @type {IFileSystemUnit['getName']} */
  getName() {
    return 'internal';
  }

  /** @type {IFileSystemUnit['getRoot']} */
  async getRoot() {
    const rootHandle = await this.storage.getDirectory();
    return new FileSystemDirectory(
      rootHandle,
      this.fileSystemManager,
      new FileSystemPath('/')
    );
  }

  /** @type {IFileSystemUnit['getInfo']} */
  async getInfo() {
    const { usage, quota } = await this.storage.estimate();
    let free;
    if (!isNil(usage) && !isNil(quota)) {
      free = quota - usage;
    }
    return {
      free: free || 0,
      total: quota || 0,
      used: usage || 0
    };
  }

  getType() {
    return FileSystemType.Internal;
  }
}

export default FileSystemUnit;
